import React, { useEffect, useState } from "react";
import {  FormControl, InputGroup } from "react-bootstrap";
import "./SubcatalogPage.css";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { fetchHeaderContent } from "../../seoroute/redux/actions";
import { MAGNIFY } from "../../comman/components/CommonimagePath";
import { SUBCATEGORY_LIST } from "../../constants/apiurl";
import { getRequestcall } from "../../comman/util/getRequest";
import default_subcat from "./../../../assets/default_subcat.svg";
import TablePage from "../../comman/table/TablePage";
import ButtonPage from "./../../comman/button/ButtonPage"

function SubcatalogPage(props) {
  const [subcategorylist, setSubcategorylist] = useState([]);
  const { t } = useTranslation();
  let getpid = window.location.pathname.split("/").pop();

  const navigate = useNavigate();
  const [searchproduct, setSearchproduct] = useState("");
  useEffect(() => {
    (async () => selectCategorychange({ value: getpid }))();
    // eslint-disable-next-line
  }, [props?.language]);

  const selectsubCategorychange = async (e, item) => {
    //setSelectsubcategory(selectsubCategory);
    onClicksubCategorychange(item);
  };
  const onClicksubCategorychange = async (item) => {
    //setSelectsubcategory(selectsubCategory);
    const data = subcategorylist?.map((item1) => {
      if (item1?.value === item?.value) {
        return {
          ...item1,
          is_check: !item?.is_check,
        };
      } else {
        return {
          ...item1,
          is_check: item1?.is_check,
        };
      }
    });
    setSubcategorylist(data);
  };
  const searchOnchange = (e) => {
    setSearchproduct(e.target.value);
  };

  const selectCategorychange = async (selectCategory) => {
    let url =
      SUBCATEGORY_LIST +
      `?category=${
        selectCategory.value
      }&for_master=yes&lang=${props?.language?.toLowerCase()}`;
    let getsubCategorylistapiresponse = await getRequestcall(
      url,
      props?.access_token
    );
    if (getsubCategorylistapiresponse?.status === 200) {
      let res = await getsubCategorylistapiresponse.json();
      let subcategoryObject = {};
      let updatedsubCategorylist = [];
      res.forEach((element) => {
        subcategoryObject = {
          value: element.id,
          label: element.title,
          title: element.title,
          title_in_tr: element.title_in_tr,
          label_tr: element.title_in_tr,
          image_url: element?.image_url,
          is_check: false,
        };
        updatedsubCategorylist.push(subcategoryObject);
      });
      setSubcategorylist(updatedsubCategorylist);
    }
  };

  const AddCatalogProducts = () => {
    const filters = subcategorylist?.filter((item) => item?.is_check === true);

    if (filters?.length === 0) {
      toast.error(t("pages.catalog.select_subcata"));
    } else {
      navigate("/vendor/products/catalog/product", {
        state: { catagory: getpid, subcatagory: filters },
      });
    }
  };
  return (
    <div className="col-xl-9 main-content productCatalog">
      <div className="card catalog_card">
        <div className="card-body catalog_body">
          <div className={"search_subcategory"}>
            <InputGroup className="mb-3 search_input">
              <InputGroup.Text id="basic-addon1">
                <img
                  src={MAGNIFY}
                  className="search-icon"
                  alt="search"
                  height="22"
                  width="22"
                ></img>
              </InputGroup.Text>
              <FormControl
                value={searchproduct}
                onChange={searchOnchange}
                placeholder={t("pages.catalog.subcategory_place")}
              />
            </InputGroup>
            <ButtonPage
              Text={t("pages.catalog.backto_cate")}
              onClick={() => navigate("..")}
              className={"button-black"}
              type="button"
            />
          </div>
          <h5 className="mb-3">{t("pages.catalog.select_subcata")}</h5>
          <TablePage
            headData={[t("pages.catalog.image"), t("pages.catalog.subcate_name")]}
            data={subcategorylist}
            search={searchproduct}
            onChange={selectsubCategorychange}
            onClick={onClicksubCategorychange}
            title={true}
            default_img={default_subcat}
          />
          <div className="d-flex justify-flex-end submit_div">
            <ButtonPage
              Text={t("pages.catalog.proceed")}
              onClick={AddCatalogProducts}
              className={
                subcategorylist?.filter((item) => item?.is_check === true)
                  ?.length === 0
                  ? "button-submit d-none"
                  : "button-submit d-block"
              }
              type="button"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
const mapStateToProps = (state) => ({
  storeDetail: state?.dashboard?.storeDetail,
  access_token: state?.login.access_token,
  categories: state?.home.categories,
  language: state?.languageState?.language,
});
export default connect(mapStateToProps, { fetchHeaderContent })(SubcatalogPage);
